
import { defineComponent, PropType } from 'vue';

// Models
import { Filter, FilterCategory, SortBy } from '../../CoffeePicker.model';

export default defineComponent({
  props: {
    isFilterActive: Boolean,
    openPickerFilter: Function as PropType<() => void>,
    currentSort: String,
    sortOptions: Array as PropType<SortBy[]>,
    filterCategories: Array as PropType<FilterCategory[]>,
    toggleFilterOption: Function as PropType<(filter: Filter) => void>,
    handleSort: Function as PropType<(sortBy: SortBy) => void>,
  },
  data() {
    return {
      showAllFiltersIds: [],
      filtersToShow: 6,
    };
  },
  methods: {
    /**
     * Toggles showing all filter items.
     */
    toggleShowAllFilters(filterCategory: FilterCategory): void {
      this.showAllFiltersIds.push(filterCategory.property);
    },
    /**
     * Handle the new sort order.
     */
    onSortChange(event: Event): void {
      const target = event.target as HTMLSelectElement;
      this.handleSort(target.value as SortBy);
    },
  },
});
